import { createUser } from '../User/UserActions';
import {
  SEND_MESSAGE,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_ERROR,
  SET_LAST_MESSAGE,
  SET_MESSAGES,
  LOAD_MESSAGES,
  SET_INTERVAL_COUNTER,
  SET_LIMIT_REACHED,
  SET_SCROLL_TO_BOTTOM,
  LOAD_MESSAGES_ERROR,
  SET_STREAMING,
} from './constants';
import axios from 'axios';

export const limitPerPage = 100;

export const sendMessageAction = message => async (dispatch, getState) => {
  dispatch({ type: SEND_MESSAGE });

  const state = getState();
  const messages = state.Messages.messages;
  const { apiUrl, apiKey, tenant } = state.Config;
  const { User } = state;
  let userId = User.user._id;

  if (!userId) {
    userId = await dispatch(createUser());
  }

  const userMessage = {
    ...message,
    timestamp: new Date().toISOString(),
    type: 'user',
  };

  dispatch({ type: SET_MESSAGES, payload: [...messages, userMessage] });
  dispatch({ type: SET_LAST_MESSAGE, payload: userMessage });

  // Add placeholder assistant message
  const assistantMsg = {
    type: 'ema',
    message: '',
    timestamp: new Date().toISOString(),
    userId,
  };

  dispatch({
    type: SET_MESSAGES,
    payload: [...messages, userMessage, assistantMsg],
  });

  try {
    const response = await fetch(`${apiUrl}/ema/live-talk`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${apiKey}`,
      },
      body: JSON.stringify({
        message: message.message,
        userId,
        tenant,
      }),
    });

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      // Split by SSE delimiter
      const parts = buffer.split('\n\n');
      buffer = parts.pop(); // save partial for next

      for (let part of parts) {
        if (part.startsWith('data: ')) {
          const json = part.replace('data: ', '');
          if (json === '[DONE]') {
            dispatch({ type: SEND_MESSAGE_SUCCESS });
            dispatch({ type: SET_STREAMING, payload: false });
            return;
          }

          try {
            const parsed = JSON.parse(json);

            // Extract actual string from structure
            const value = parsed?.content?.[0]?.text?.value;

            if (typeof value === 'string') {
              const updatedMessages = [...getState().Messages.messages];
              const last = updatedMessages[updatedMessages.length - 1];
              if (last && last.type === 'ema') {
                last.message += value;
                dispatch({ type: SET_MESSAGES, payload: updatedMessages });
                dispatch({ type: SET_STREAMING, payload: true });
                dispatch(setScrollToBottom(true));
              }
            }
          } catch (err) {
            console.error('❌ JSON parse error in stream:', err, json);
          }
        }
      }
    }
  } catch (error) {
    dispatch({ type: SEND_MESSAGE_ERROR, payload: error.message });
    console.error('Streaming error:', error);
  } finally {
    dispatch({ type: SET_INTERVAL_COUNTER, payload: 30 });
  }
};

export const loadMessages =
  (userId, page = 1) =>
  async (dispatch, getState) => {
    dispatch({ type: LOAD_MESSAGES });
    console.log('Loading messages', userId);
    const state = getState();
    const { apiUrl, tenant, apiKey } = state.Config;
    if (userId) {
      try {
        const response = await axios.get(
          `${apiUrl}/ema/messages?userId=${userId}&page=${page}&per_page=${limitPerPage}&tenant=${tenant}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${apiKey}`,
            },
          },
        );

        let buffer = response.data['messages'].map(message => {
          if (message.sender === 'user') {
            return {
              type: 'user',
              message: message.message,
              timestamp: message.timestamp,
              id: message._id,
              userId: message.userId,
              flag: message.flag,
            };
          } else {
            return {
              type: 'ema',
              message: message.message,
              timestamp: message.timestamp,
              id: message._id,
              userId: message.userId,
              flag: message.flag,
            };
          }
        });

        let sortedBuffer = buffer.sort(
          (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
        );

        if (buffer.length > 0) {
          dispatch({ type: SET_MESSAGES, payload: sortedBuffer });
        }

        const { Messages } = getState();
        const {
          intervalCounter,
          busyMessage,
          limitMessage,
          messageLimit,
          messages,
        } = Messages;

        if (buffer.length > 0 && buffer[buffer.length - 1].type === 'ema') {
          dispatch({ type: SET_INTERVAL_COUNTER, payload: 0 });
        } else if (intervalCounter < 2) {
          if (busyMessage) {
            console.log('busyMessage:', busyMessage);
            dispatch({
              type: SET_MESSAGES,
              payload: [
                ...messages,
                {
                  type: 'ema',
                  message: busyMessage,
                },
              ],
            });
          } else {
            dispatch({
              type: SET_MESSAGES,
              payload: [
                ...messages,
                {
                  type: 'ema',
                  message:
                    "Sorry to keep you waiting, I'll respond to you as soon as possible!",
                },
              ],
            });
            console.error('No busyMessage found for the current tenant.');
          }
          dispatch({ type: SET_INTERVAL_COUNTER, payload: 0 });
        }

        //If there is a limit, and its not in a quiz, we check it
        if (
          messageLimit &&
          (!response.data['conversation'] ||
            !(
              response.data['conversation'].status.toUpperCase() == 'INQUIZ'
            )) &&
          response.data['pagination'].total > messageLimit
        ) {
          if (limitMessage) {
            console.log('limitMessage:', limitMessage);
            dispatch({
              type: SET_MESSAGES,
              payload: {
                type: 'ema',
                message: limitMessage,
              },
            });
          } else {
            console.error('No limitMessage found for the current tenant.');
          }
          dispatch({ type: SET_LIMIT_REACHED });
        }
      } catch (e) {
        dispatch({ type: LOAD_MESSAGES_ERROR, payload: e.message });
        console.log('Error loading messages', e.message);
      }
    }
  };

export const setScrollToBottom = payload => async dispatch => {
  dispatch({ type: SET_SCROLL_TO_BOTTOM, payload });
};

export const setIntervalCounter = payload => async dispatch => {
  dispatch({ type: SET_INTERVAL_COUNTER, payload });
};
